module.exports = __webpack_public_path__ + "media/fonts/formular-bold-webfont-70f6aea52330f98efd204a24d3cf4d66.woff2";